import { Skeleton } from '@/components/ui/skeleton.component';
import { cn } from '@/utils/cn-tw-merge';

interface SlotsSkeletonProps {
  variant?: 'card' | 'modal';
  columns?: number;
  className?: string;
}

const DEFAULT_MODAL_COLUMNS = 3;
const MODAL_SLOTS_PER_COLUMN = 4;

export function SlotsSkeleton({
  variant = 'card',
  columns = DEFAULT_MODAL_COLUMNS,
  className,
}: SlotsSkeletonProps) {
  if (variant === 'card') {
    return (
      <div className={cn('flex flex-col gap-2', className)} role="status" aria-label="Carregando horários">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
    );
  }

  return (
    <div className={cn('flex flex-col gap-3', className)} role="status" aria-label="Carregando horários">
      <div className="flex gap-4">
        {Array.from({ length: columns }).map((_, colIdx) => (
          <div key={colIdx} className="flex flex-1 flex-col gap-2 items-center">
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-5 w-10" />
            {Array.from({ length: MODAL_SLOTS_PER_COLUMN }).map((__, rowIdx) => (
              <Skeleton key={rowIdx} className="h-9 w-full" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
